import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatesSelect from "./DatesSelect";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { getAllSalesOverView } from "../../../redux/service/action";
import SalesReportExport from "./SalesReportExport";

const SalesReport = ({ selectedOptions, testingAccountFilter = "hide" }) => {
  console.log(selectedOptions, "selectedOptionsselectedOptions");
  const [params, setParams] = useState({
    type: "sale_report",
    start_date: "",
    end_date: "",
    user_id: selectedOptions,
    testing_account_filter: testingAccountFilter,
  });

  const dispatch = useDispatch();
  const salesReportData = useSelector(
    (state) => state?.reusableSlice?.getSalesData
  );
  console.log(salesReportData, "salesReportData");
  // const chartData =
  //   salesReportData?.sale_report?.map(({ month_name, total }) => ({
  //     name: month_name,
  //     sales: total,
  //   })) || [];
  const chartData = Array.isArray(salesReportData?.sale_report)
    ? salesReportData.sale_report.map(({ month_name, total }) => ({
        name: month_name,
        sales: total,
      }))
    : [];

  useEffect(() => {
    dispatch(getAllSalesOverView(params));
  }, [dispatch, params]);

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      user_id: selectedOptions,
      testing_account_filter: testingAccountFilter,
    }));
  }, [selectedOptions, testingAccountFilter]);

  return (
    <div
      style={{
        width: "100%",
        padding: 20,
        background: "#F1F1F8",
        borderRadius: 10,
      }}
    >
        <div
          className="d-flex align-items-center justify-content-between w-100 pb-5"
          style={{ columnGap: "20px" }}
        >
          <div
            className="d-flex align-items-center "
            style={{ columnGap: "30px" }}
          >
            <h4  className="w-100">Sales Overview</h4>
            <DatesSelect setParams={setParams} />
          </div>
          <SalesReportExport params={params}></SalesReportExport>
        </div>

      <ResponsiveContainer width="100%" height={250}>
        <AreaChart
          data={chartData}
          margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#7367F0" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#7367F0" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="sales"
            stroke="#7367F0"
            fill="url(#colorSales)"
            strokeWidth={1.5}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesReport;
